import { Action } from 'redux';

import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface ForumFeedLikedFetchAction extends Action {
    readonly after: number; // Last item id
}

export const FEED_LIKED_FETCH_REQUEST = 'FEED_LIKED_FETCH_REQUEST';
export interface FeedLikedFetchRequestAction extends ForumFeedLikedFetchAction, APIRequestAction {
    readonly type: typeof FEED_LIKED_FETCH_REQUEST;
}
export interface FeedLikedFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { posts: number[]; };
}
export const FEED_LIKED_FETCH_SUCCESS = 'FEED_LIKED_FETCH_SUCCESS';
export interface FeedLikedFetchSuccessAction extends ForumFeedLikedFetchAction, APISuccessAction<FeedLikedFetchNormalizedResponse> {
    readonly type: typeof FEED_LIKED_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly notificationsOn: number[];
}

export const FEED_LIKED_FETCH_FAILURE = 'FEED_LIKED_FETCH_FAILURE';
export interface FeedLikedFetchFailureAction extends ForumFeedLikedFetchAction, APIFailureAction {
    readonly type: typeof FEED_LIKED_FETCH_FAILURE;
}

export const feedLikedFetch = {
    request: (after: number): FeedLikedFetchRequestAction => ({ type: FEED_LIKED_FETCH_REQUEST, after }),
    success: (after: number, hasNext: number, hasPrevious: number, notificationsOn: number[], response: FeedLikedFetchNormalizedResponse): FeedLikedFetchSuccessAction => ({
        type: FEED_LIKED_FETCH_SUCCESS, after, hasNext, hasPrevious, notificationsOn, response,
    }),
    failure: (after: number, error: any): FeedLikedFetchFailureAction => ({ type: FEED_LIKED_FETCH_FAILURE, after, error }),
};

// Feed Liked load
export const FEED_LIKED_LOAD = 'FEED_LIKED_LOAD';
export interface FeedLikedLoadAction extends ForumFeedLikedFetchAction {
    readonly type: typeof FEED_LIKED_LOAD;
    readonly username: string;
}
export const feedLikedLoad = (username: string, after?: number): FeedLikedLoadAction => ({
    type: FEED_LIKED_LOAD, username, after,
});
